export { default as BorrowerData } from './BorrowerData';
export { default as BorrowerDataForm } from './BorrowerDataForm';
export { default as BorrowerIdCardForm } from './BorrowerIdCardForm';
export { default as BorrowerDocuments } from './BorrowerDocuments';
export { default as BorrowerDocumentsHistory } from './BorrowerDocumentsHistory';
export { default as BorrowersTableHeader } from './TableHeader';
export { default as BorrowerDocumentsTab } from './BorrowerDocumentsTab';
export { default as BorrowerContractsTab } from './BorrowerContractsTab';
export { default as BorrowerCreditsTab } from './BorrowerCreditsTab';
export { default as BorrowerCredits } from './BorrowerCredits';
export { default as BorrowerContactsTab } from './BorrowerContactsTab';
export { default as BorrowerHistoryTab } from './BorrowerHistoryTab';
export { default as BorrowerDetailsTab } from './BorrowerDetailsTab';
export { default as BorrowerFiles } from './BorrowerFiles';
export { default as BorrowerActionsTab } from './BorrowerActionsTab';
export { default as BorrowerWorkPlaceForm } from './BorrowerWorkPlaceForm';
export { default as BorrowerWorkPlaceTab } from './BorrowerWorkPlaceTab';
export { default as BorrowerWorkPlaceData } from './BorrowerWorkPlaceData';
export { default as BorrowerIncomeTab } from './BorrowerIncomeTab';
export { default as BorrowerIncomeForm } from './BorrowerIncomeForm';
export { default as BorrowerIncomeItem } from './BorrowerIncomeItem';
export { default as BorrowerExpenseTab } from './BorrowerExpenseTab';
export { default as BorrowerExpensesForm } from './BorrowerExpensesForm';
export { default as BorrowerExpensesData } from './BorrowerExpensesData';
export { default as BorrowerExternalCreditTab } from './BorrowerExternalCreditTab';
export { default as BorrowerExternalCreditForm } from './BorrowerExternalCreditForm';
export { default as BorrowerExternalCreditItem } from './BorrowerExternalCreditItem';
export { default as IdCardScanModal } from './IdCardScanModal';